module.exports = __webpack_public_path__ + "img/content.68a66bf4.png";